import { BankAccount } from '../data';

export const getId = (bankAccount?: BankAccount) => bankAccount?.id;
export const getLastTransactedAt = (bankAccount: BankAccount): number =>
  bankAccount.lastTransactedAt ? Date.parse(bankAccount.lastTransactedAt) : 0;
export const isBettermentChecking = (bankAccount: BankAccount | undefined): boolean =>
  bankAccount?.isBettermentChecking === true;

export function sortByLastTransacted(bankAccounts: BankAccount[]): BankAccount[] {
  return bankAccounts
    .filter(({ lastTransactedAt }) => lastTransactedAt)
    .sort((a, b) => getLastTransactedAt(b) - getLastTransactedAt(a));
}

export function defaultBankAccount(bankAccounts: BankAccount[]): BankAccount | undefined {
  const [defaultAccount] = sortByLastTransacted(bankAccounts);
  const selectedAccount = defaultAccount || (bankAccounts.length === 1 ? bankAccounts[0] : undefined);

  return !selectedAccount?.isPendingManualLink ? selectedAccount : undefined;
}
